import { render } from "./WordChart.vue?vue&type=template&id=6ace25bf&scoped=true&ts=true"
import script from "./WordChart.vue?vue&type=script&lang=ts"
export * from "./WordChart.vue?vue&type=script&lang=ts"

import "./WordChart.vue?vue&type=style&index=0&id=6ace25bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ace25bf"]])

export default __exports__